<template>
  <div class="meter-form">
    <h4>{{ $t("group.groupMeterForm.header") }}</h4>
    <input
      type="radio"
      id="parent"
      value="Parent"
      v-model="meterType"
      v-on:change="changeMeterType"
    >
    <label for="parent">{{ $t("group.groupMeterForm.parent") }}</label>
    <input
      type="radio"
      id="own"
      value="Own"
      v-model="meterType"
      v-on:change="changeMeterType"
    >
    <label for="own">{{ $t("group.groupMeterForm.own") }}</label>

    <div class="meters">
      <!-- Parent -->
      <h3 v-if="meterType === 'Parent'" class="light parent-meter">{{ $t("group.groupMeterForm.creditsAvailable") }}: <strong class="error">{{ parentCredits }}</strong></h3>

      <!-- Own -->
      <h3 v-if="meterType === 'Own'" class="light local-meter">{{ $t("group.groupMeterForm.localCreditsAvailable") }}: <strong class="error">{{ localCredits }}</strong></h3>
      <h4 v-if="meterType === 'Own'" class="light parent-meter">{{ $t("group.groupMeterForm.parentCredits") }}: <strong>{{ parentCredits }}</strong></h4>
    </div>

    <div v-if="meterType === 'Own'" class="credits-form">
      <h4>{{ $t("group.groupMeterForm.allocate") }}</h4>
      <input
        id="update-credits"
        maxlength="8"
        v-model="updateLocalCredits"
        v-bind:class="{ error: errUpdateCredits }"
      >
      <button v-on:click="updateMeter">{{ $t("group.groupMeterForm.button.update") }}</button>
    </div>

  </div>
</template>

<script>
import { groupService } from '@/services/group.service'
import { planService } from '@/services/plan.service'

export default {
  name: 'GroupMeterForm',
  props: ['meter', 'groupName', 'groupId', 'planId', 'role'],
  data: function () {
    return {
      errUpdateCredits: false,

      meterType: this.meter,
      parentCredits: 0,
      localCredits: 0,
      updateLocalCredits: 0
    }
  },
  created: function () {
    this.fetchMeter()
  },
  methods: {
    updateMeter: function () {
      this.errUpdateCredits = false

      // Has to be a number and you can't allocate more credits
      // than the plan has.
      if(isNaN(this.updateLocalCredits)
        || !Number.isInteger(Number(this.updateLocalCredits))
        || (Number(this.updateLocalCredits) + Number(this.localCredits) > Number(this.parentCredits))) {
        this.errUpdateCredits = true
      }
      else {
        this.addCredits()
      }
    },
    addCredits: function () {
      let transaction = {
        count: this.updateLocalCredits,
        message: 'Credits added to ' + this.groupName,
        groupId: this.groupId
      }

      if(this.role !== 'Owner' && this.role !== 'Member'){
        this.transferMeter(transaction)
      } else {
        this.transferMeterByOwner(transaction)
      }
    },
    // Transfer local credits back to parent plan.
    removeLocalCredits: function () {
      let transaction = {
        count: -(Number(this.updateLocalCredits)),
        message: 'Returning credits from ' + this.groupName,
        groupId: this.groupId
      }

      if(this.role !== 'Owner' && this.role !== 'Member'){
        this.transferMeter(transaction)
      } else {
        this.transferMeterByOwner(transaction)
      }
    },
    changeMeterType: function () {
      let meterActive = true

      // Going back to parent? We need to handle credits.
      if(this.meterType === 'Parent') {
        meterActive = false
        if(Number(this.localCredits) > 0) {
          this.removeLocalCredits()
        }
      }

      let group = {
        enabled: true,
        meterActive: meterActive
      }
      groupService.updateGroup(this.groupId, group).then(() => {
        this.fetchMeter()
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    },
    fetchMeter: function () {
      this.updateLocalCredits = 0

      if(this.role !== 'Owner' && this.role !== 'Member'){
        this.fetchParentMeter()
      } else {
        this.fetchParentMeterByOwner()
      }

      if(this.meterType == 'Own') {
        this.fetchOwnMeter()
      }
    },
    fetchOwnMeter: function () {
      groupService.getMeter(this.groupId).then(meter => {
        this.localCredits = meter.currentValue
      }).catch((err) => {
        console.error('Unable to fetch group meter: ', err)
      })
    },
    fetchParentMeter: function () {
      planService.meter(this.planId).then(meter => {
        this.parentCredits = meter.currentValue
      }).catch((err) => {
        console.error('Unable to fetch parent meter: ', err)
      })
    },
    fetchParentMeterByOwner: function () {
      planService.meterByOwner(this.planId).then(meter => {
        this.parentCredits = meter.currentValue
      }).catch((err) => {
        console.error('Unable to fetch parent meter by Group Admin: ', err)
      })
    },
    transferMeter: function (transaction) {
      planService.transferCredits(this.planId, transaction).then(() => {
        this.fetchMeter()
      }).catch((err) => {
        console.error('Something went wrong transfering credits: ', err)
      })
    },
    transferMeterByOwner: function (transaction) {
      planService.transferCreditsByOwner(this.planId, transaction).then(() => {
        this.fetchMeter()
      }).catch((err) => {
        console.error('Something went wrong transfering credits by Group Admin: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.meter-form {
  margin-top: 30px;
}

input {
  display: inline-block;
}

button {
  min-width: 0;
  padding: 7px 43px;
  margin: 0;
}

#update-credits {
  width: 113px;
  margin-right: 12px;
  height: 54px;
}

label {
  display: inline-block;
  font-weight: $regular;
  line-height: 23px;
}

.meters {
  margin-bottom: 30px;

  h3, h4 {
    display: inline-block;
    margin-right: 20px;
  }
  strong {
    font-weight: $bold;
  }
}
h3 {
  font-size: 20px;
}
</style>
